import React from 'react';
import Modal from 'react-modal';
import Input from '../../TravellerContactInfo/FormFields/Input';

import '../LoginModals.css';
import { If } from 'react-extras';
import { customStyles, UserFlowModalState } from '../../UserFlow/UserFlowModal';
import { useForgotPasswordContainer } from './ForgotPasswordContainer';

const ForgotPassword = (props: UserFlowModalState) => {
  const {
    state: {
      showModal,
      userStatus,
      rotate,
      validationFail,
      disabled,
    },

    action: {
      rotateLoader,
      handleInputKeyUpViaParent,
      closeModal,
      userNameVerified,
    },
  } = useForgotPasswordContainer(props);

  const { switchModal, allowClose } = props;

  const { userId } = userStatus;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals htmlv2"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="leftPanel">
        <p className="modalTitle font26 latoBloack blackText">
            Username Verified!
        </p>
        <p className="font20 latoBold darkGreyText appendBottom10">
            Do you remember your password?
        </p>
        <p className="font14 darkGreyText appendBottom40">
          Password is required by IRCTC for authentication after payment and <span className="redText">your booking might fail</span> if you don’t remember it.
        </p>
        <div className="makeFlex appendBottom50 end">
          <div className={`makeFlex column appendRight2 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC USERNAME"
              errorMessage="Please enter OTP."
              validationFail={false}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              handleInputKeyUpViaParent={handleInputKeyUpViaParent}
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
        </div>
        <p>
          <a className="font16 latoBold" onClick={userNameVerified}>Continue Booking</a>
        </p>
      </div>
      <div className="rightPanel">
        <If condition={allowClose === true}>
          <p className="textRight modalCloseCont">
            <span
              className="modalClose railSprite crossIcon"
              onClick={closeModal}
            />
          </p>
        </If>

        <p className="font20 latoBold darkGreyText appendBottom10">Reset IRCTC Password</p>
        <p className="font14 appendBottom30">Enter the mobile number registered with your IRCTC account and get password (in 4-5 mins).</p>

        <div className="appendBottom50 end">
          <div className={`makeFlex column appendRight2 appendBottom40 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="MOBILE NUMBER"
              errorMessage="Please enter number."
              validationFail={false}
              type="text"
              additionalAttributes={{ placeholder: 'Enter Mobile Number' }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg=""
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly={false}
              handleInputKeyUpViaParent={handleInputKeyUpViaParent}
              value={userStatus &&
                userStatus.mobileEntered}
            />
          </div>

          <button
            onClick={rotateLoader}
            className={`${disabled ? 'disabled' : ''} noShrink width220`}
          >
            <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>Get Password on SMS</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ForgotPassword;
